import type { DeclineEstimateResponsePayload } from '@massilia/contracts'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { publicEstimateKeys } from './keys.js'
import { quoteAuthHeaders } from './quote-token.js'

export const useDeclinePublicQuoteMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      responseId,
      ...payload
    }: DeclineEstimateResponsePayload & { responseId: string }) => {
      const response = await apiClient.client.post(
        `/public/estimate-responses/${responseId}/decline`,
        payload,
        { headers: quoteAuthHeaders(responseId) }
      )
      return response.data
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: publicEstimateKeys.quote(variables.responseId),
      })
    },
  })
}
